"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateRazorpayOrder = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const razorpayAction_1 = require("./razorpayAction");
const useCreateRazorpayOrder = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createRazorpayOrderLoading = (0, react_redux_1.useSelector)((state) => state['razorpay/create'].loading);
    const createRazorpayOrderError = (0, react_redux_1.useSelector)((state) => state['razorpay/create'].error);
    const createRazorpayOrderData = (0, react_redux_1.useSelector)((state) => state['razorpay/create'].data);
    const createRazorpayOrder = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, razorpayAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in creating order");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createRazorpayOrderLoading,
        createRazorpayOrderError,
        createRazorpayOrderData,
        createRazorpayOrder
    };
};
exports.useCreateRazorpayOrder = useCreateRazorpayOrder;
